import { render, staticRenderFns } from "./thietLapKySo.vue?vue&type=template&id=06b31bd9&scoped=true&"
import script from "./thietLapKySo.vue?vue&type=script&lang=js&"
export * from "./thietLapKySo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b31bd9",
  null
  
)

export default component.exports